import { IApplicationState } from '../../types/redux';

export function getDeveloperRatings(state: IApplicationState) {
  return state.developer.ratings;
}
